<template>
  <svg class="icon"
    :class="iconSizeClass"
      xmlns="http://www.w3.org/2000/svg">
      <title v-if="title">{{ title }}</title>
      <use :xlink:href="iconPath"
          xmlns:xlink="http://www.w3.org/1999/xlink" />
  </svg>
</template>

<script>
const SIZES = ['small', 'base', 'medium', 'big', 'huge'];

export default {
  name: 'SvgIcon',

  props: {
      name: {
          type: String,
          required: true
      },

      title: {
          type: String,
          default: null
      },
      size: {
        type: String,
        required: false,
        default: 'base',
        validator: function(size) {
          return SIZES.includes(size);
        }
      }
  },

  computed: {
    iconPath() {
		let icon = require(`@/assets/icons/svg/${this.name}.svg`);
		
		if (Object.prototype.hasOwnProperty.call(icon, 'default')) {
			icon = icon.default;
		}
		
        return icon.url;
      },
      iconSizeClass() {
        return `icon--size-${this.size}`
      }
  }
};
</script>
